import z from "zod";

export const modalAddExtraAttachmentFormSchema = z.object({
  extraAttachments: z
    .array(
      z.object({
        fileSignedId: z.string({
          error:
            "order.catalogMediumConfiguration.stepVersions.errorNoFileOutput",
        }),
        isLoading: z.boolean().optional(),
      })
    )
    .min(1),
});

export type InferredModalAddExtraAttachmentSchema = z.infer<
  typeof modalAddExtraAttachmentFormSchema
>;
